import request from '@/utils/request'

export const getOpeningBalances = () => request.get('/accounting/opening-balances')

export const createOpeningBalance = data => request.post('/accounting/opening-balances', data, { rawResponse: true })
